// Per-source "⋯" menu (F-04.8): on each pane and on each card of the 素材 tab. Replace, align, swap with A, view
// alone, remove (at once, no confirmation: the owner prefers setting it again).

import type { App } from '../app/app';
import type { SourceId } from '../core/types';
import { t } from '../i18n';
import { pasteLinks, pickSequenceFolder, pickVideos } from './interactions';
import { showMenu, type MenuItem } from './project-tree';

export function openSourceMenu(app: App, id: SourceId, x: number, y: number): void {
  const src = app.sources.source(id);
  if (!src) return;
  const isA = id === 'A';
  const single = app.project.layout.layout === 'single' && app.project.layout.focusSourceId === id;
  const items: (MenuItem | null)[] = [
    { label: t(src.sequence ? 'srcmenu.replaceSeq' : 'srcmenu.replace'), run: () => (src.sequence ? pickSequenceFolder(app, id) : pickVideos(app, id)) },
    { label: t('srcmenu.replaceLink'), run: () => pasteLinks(app, id) },
    null,
    ...(isA
      ? []
      : [
          {
            label: t('srcmenu.align'),
            run: () => {
              app.selectB(id);
              app.store.ui((u) => (u.alignOpen = true));
            },
          },
          { label: t('srcmenu.swapA'), run: () => app.sources.swap('A', id) },
        ]),
    {
      label: t(single ? 'srcmenu.viewAll' : 'srcmenu.viewAlone'),
      run: () =>
        app.store.project(
          (p) => {
            if (single) p.layout.layout = app.sources.loadedIds().length >= 3 ? 'quad' : 'side-by-side-zoom';
            else {
              p.layout.layout = 'single';
              p.layout.focusSourceId = id;
            }
          },
          { undo: false },
        ),
    },
    null,
    { label: t('srcmenu.remove', { id }), run: () => app.removeSource(id), danger: true },
  ];
  showMenu(items, x, y);
}
